/* @flow */
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import './styles/CircleSpinner.scss';

class CircleSpinner extends React.Component {
  static propTypes = {
    color: React.PropTypes.oneOf(['shamrock', 'jungle']),
    size: React.PropTypes.oneOf(['medium', 'small']),
  };

  static propClasses = {
    size: {
      medium: 'CircleSpinner-medium',
      small: 'CircleSpinner-small',
    },
    color: {
      shamrock: 'CircleSpinner-shamrock',
      jungle: 'CircleSpinner-jungle',
    },
  };

  static defaultProps = {
    color: 'brand',
    size: 'medium',
  };

  render() {
    return (
      <div
        className={cx(
          'CircleSpinner',
          getPropClassesFromInstance(this),
          this.props.className
        )}
      />
    );
  }
}

export default CircleSpinner;



// WEBPACK FOOTER //
// ./src/components/CircleSpinner.jsx